const endpoints = {
	addCrmEntry: '/crm/addCrmEntry',
	deleteCrmEntry: '/crm/deleteCrmEntry',
	archiveCrmEntry: '/crm/archiveCrmEntry',
	restoreCrmEntry: '/crm/restoreCrmEntry',
	editCrmValue: '/crm/editCrmValue',
	editCrmProjectDetail: '/crm/editCrmProjectDetail',
	editCrmProjectType: '/crm/editCrmProjectType',
	editCrmZoneIpt: '/crm/editCrmZoneIpt',
	editContractValue: '/crm/editContractValue',
	editCrmResponsible: '/crm/editCrmResponsible',
	assignScheduleToUser: '/crm/assignScheduleToUser',
}
export {endpoints}